import { useState, useEffect } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import { Spin } from 'antd'

export default function Testing() {
  const { oid, code } = useParams()
  const navigate = useNavigate()
  const [questions, setQuestions] = useState([])
  const [currentSort, setCurrentSort] = useState(1)
  const [selectedOption, setSelectedOption] = useState(null)
  const [answers, setAnswers] = useState([])
  const [loading, setLoading] = useState(false)
  const location = useLocation()
  const formData = location.state?.formData || {}

  useEffect(() => {
    document.title = '职业生涯测评'

    axios.post('/c/assessment/questions/get', {
      code: code,
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setQuestions(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [code])

  const handleOptionClick = (option) => {
    if (selectedOption) return
    setSelectedOption(`${currentQuestion.sort}-${option.code}`)

    setTimeout(() => {
      const newAnswer = {
        sort: currentQuestion.sort,
        code: option.code,
        score: option.score || 0,
      }

      const updatedAnswers = [...answers, newAnswer]
      setAnswers(updatedAnswers)
      setSelectedOption(null)

      if (currentSort < questions.length) {
        setCurrentSort(currentSort + 1)
      } else {
        setLoading(true)
        setTimeout(() => {
          navigate(`/result/${oid}/${code}`, { state: { answers: updatedAnswers, formData: formData} })
        }, 2000)
      }
    }, 500)
  }

  if (!questions.length) {
    return <div>...</div>
  }

  const currentQuestion = questions.find(q => q.sort === currentSort)

  return (
    <Spin spinning={loading} tip="计算中..." size="large">
    <div className='testing-page'>
      <img className='testing-bg' src='/images/testing-bg.png' alt="" />
      <div className='testing-serial'>
        <div className='testing-serial-up'>{currentSort}</div>
        <div className='testing-serial-down'>第{currentSort}题 / 共{questions.length}题</div>
      </div>

      <div className='testing-content'>
        <div className='testing-title'>{currentQuestion.title}</div>
        <div className='testing-options'>
          {currentQuestion.options.map((opt) => {
            const isSelected = selectedOption === `${currentQuestion.sort}-${opt.code}`
            return (
              <div key={opt.code} className={`testing-option ${isSelected ? 'selected' : ''}`} onClick={() => handleOptionClick(opt)}>
                <span>{opt.code}：</span>
                <span>{opt.text}</span>
              </div>
            )
          })}
        </div>
      </div>
    </div>
    </Spin>
  )
}
